import { jsx as _jsx } from "react/jsx-runtime";
import styles from './FooterLegalLinksContainer.module.scss';
import cx from 'classnames';
export const FooterLegalLinksContainer = ({ children, isCheckout = false, isFooterLinksSortActive }) => (_jsx("div", { className: cx('d-flex', isFooterLinksSortActive
        ? [styles['footer__legal__links_sort-container']]
        : [styles['footer__legal__links-container']], {
        [styles['footer__legal__links-container_border']]: !isCheckout
    }), children: children }));
